import CONFIGS from 'build/Config'
import Header from '../components/Header'
import RankingDescription from '../components/RankingDescription'
import PointPosition from '../components/PointPosition'
import RankingListItems from '../components/RankingListItems'
import RankingFinished from '../components/RankingFinished'

const RankingList = ({ ranking }: { ranking?: any }) => {
  return (
    <section className='ranking'>
      <Header />
      {CONFIGS?.rankingDisabled && <RankingFinished />}
      <RankingDescription />
      <PointPosition ranking={ranking} />
      <RankingListItems ranking={ranking} />
    </section>
  )
}

export default RankingList